import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js"

window.addEventListener('load', function() {

  var datepicker = document.querySelector('#datepicker');

  if(!datepicker)
    return;

  var options = {
    altInput: true,
    altFormat: "j F Y",
    dateFormat: "Y-m-d",
    locale: French,
  };

  if (datepicker.dataset.date) {
    options.defaultDate = datepicker.dataset.date;
  }

  flatpickr(datepicker, options);

});
